import React, { FC } from 'react'

import { IconTobiProps } from './IconTobi.types'
import * as Styled from './styles/IconTobi.style'

import { nonThemeableRules } from '../../ruleSet'

const IconTobi: FC<IconTobiProps> = ({
  size = nonThemeableRules.defaultSize as number as IconTobiProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconTobiProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 68 68' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none' fillRule='evenodd'>
          <circle cx='34' cy='34' fill='#FFF' fillRule='nonzero' r='34' />
          <path
            d='M47.544 31.356h-.142c-.1.081-.223.163-.344.244a13.236 13.236 0 0 1-3.055 1.46 26.23 26.23 0 0 1-4.005.973 37.59 37.59 0 0 1-12.058 0c-3.197-.547-5.827-1.5-7.385-2.697a2.195 2.195 0 0 0-1.76.831 3.582 3.582 0 0 0-.688 1.521v5.393c0 .284.02.569.04.832.709 8.76 8.356 15.268 17.096 14.579 7.748-.63 13.899-6.793 14.546-14.579.02-.284.04-.548.04-.832V33.71a4.501 4.501 0 0 0-.687-1.521 2.225 2.225 0 0 0-1.598-.832Z'
            fill='#EBEBEB'
          />
          <path
            d='M14.304 39.102a4.77 4.77 0 0 1-.284-1.602v1.602a5.065 5.065 0 0 0 5.058 5.07 13.512 13.512 0 0 1-.587-2.008 4.637 4.637 0 0 1-4.187-3.062m39.23 0c-.639 1.764-2.259 2.98-4.12 3.062-.14.67-.34 1.338-.58 2.007 2.761 0 5-2.27 5-5.069V37.5c0 .548-.099 1.095-.3 1.602'
            fill='#900'
          />
          <path
            d='M14.02 33.445c0 .122-.02.223-.02.344v3.732a4.663 4.663 0 0 0 4.45 4.663c-.16-.73-.282-1.48-.343-2.23-.023-.284-.04-.548-.04-.832-.014-.284-.014-.432 0-.445v-4.948a3.835 3.835 0 0 1 .688-1.52 2.134 2.134 0 0 1 1.76-.832c1.557 1.176 4.188 2.15 7.384 2.696a37.529 37.529 0 0 0 12.058 0 26.56 26.56 0 0 0 3.986-.973 13.236 13.236 0 0 0 3.055-1.46c.12-.08.242-.162.343-.243h.142c.627.02 1.234.325 1.619.832.344.445.586.973.687 1.52v5.393c0 .285-.02.568-.04.832-.06.75-.182 1.5-.344 2.23a4.7 4.7 0 0 0 4.148-3.041 4.744 4.744 0 0 0 .283-1.582v-2.21c.04-.405.04-.831.04-1.298C53.937 22.963 44.994 14 33.97 14c-10.804 0-19.645 8.617-19.949 19.445Z'
            fill='#E60000'
          />
          <path
            d='M38.035 26.612a4.101 4.101 0 0 1-1.194 1.44 4.45 4.45 0 0 1-4.005.77 4.755 4.755 0 0 1-2.65-1.987 5.335 5.335 0 0 1-.608-1.338c0-.041-.02-.061-.02-.102a3.782 3.782 0 0 1-.141-.81c-.02-.285-.04-.569-.02-.853v-.08c.02-.406.08-.812.181-1.197a7.256 7.256 0 0 1 2.327-3.73 7.946 7.946 0 0 1 2.266-1.339c.223-.081.465-.162.688-.223l.425-.121a8.664 8.664 0 0 1 1.051-.183 4.518 4.518 0 0 1 1.053 0c.06 0 .12.02.161.04-1.558.345-2.69 1.724-2.69 3.326v.101a5.44 5.44 0 0 1 1.76.67c.445.283.85.628 1.153 1.054l.06.101c.224.324.385.69.506 1.075.122.385.183.79.203 1.196v.162a4.764 4.764 0 0 1-.506 2.028M33.97 16.068c-4.593 0-8.295 3.731-8.295 8.313 0 4.583 3.722 8.314 8.295 8.314 4.572 0 8.295-3.731 8.295-8.314 0-4.602-3.723-8.313-8.295-8.313'
            fill='#FFF'
          />
          <path
            d='M42.653 45.994a.77.77 0 0 0-1.094 0c-4.237 4.299-11.08 4.299-15.297 0a.77.77 0 0 0-1.094 0 .806.806 0 0 0 0 1.114l.04.042c4.834 4.907 12.651 4.886 17.485-.021.279-.324.279-.831-.04-1.135M25.026 39.39a2.505 2.505 0 0 0 3.035 1.802 2.516 2.516 0 0 0 1.796-1.802c.33-1.347-.475-2.714-1.796-3.046-1.342-.33-2.704.477-3.035 1.802-.04.208-.082.415-.082.622v.042c0 .207.041.394.082.58m12.987.019a2.502 2.502 0 0 0 3.03 1.784 2.5 2.5 0 0 0 1.792-1.784c.041-.144.062-.287.062-.452v-.164a2.483 2.483 0 0 0-2.452-2.523 2.484 2.484 0 0 0-2.535 2.441c0 .246.021.472.103.698'
            fill='#4A4D4E'
          />
        </g>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconTobi
